import { render, staticRenderFns } from "./OrderingNumber.vue?vue&type=template&id=19fae4a7&"
import script from "./OrderingNumber.vue?vue&type=script&lang=js&"
export * from "./OrderingNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports